const map = {
	"./asort-logo.jpeg": 994,
	"./bytedancelogo.png": 2546,
	"./ds-image.svg": 1651,
	"./flexport_logo.jpeg": 3675,
	"./hackathon1.svg": 7392,
	"./mlh-logo.svg": 5723,
	"./mongo.png": 948,
	"./muj-logo.png": 5474,
	"./postman.jpg": 2694,
	"./postman.png": 3826,
	"./ra-logo.png": 8701,
	"./skillenza.png": 6613,
	"./ssec.png": 6704,
	"./ssgandhy.png": 1727,
	"./usclogo.png": 890,
	"./valora.jpg": 7737,
	"./wrighter.jpg": 8296
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;